
export const euCountries = [
  { code: "GB", name: "United Kingdom", flag: "🇬🇧", supported: true },
  { code: "AT", name: "Austria", flag: "🇦🇹", supported: true },
  { code: "BE", name: "Belgium", flag: "🇧🇪", supported: true },
  { code: "BG", name: "Bulgaria", flag: "🇧🇬", supported: true },
  { code: "HR", name: "Croatia", flag: "🇭🇷", supported: true },
  { code: "CZ", name: "Czech Republic", flag: "🇨🇿", supported: true },
  { code: "DK", name: "Denmark", flag: "🇩🇰", supported: true },
  { code: "EE", name: "Estonia", flag: "🇪🇪", supported: true },
  { code: "FI", name: "Finland", flag: "🇫🇮", supported: true },
  { code: "FR", name: "France", flag: "🇫🇷", supported: true },
  { code: "DE", name: "Germany", flag: "🇩🇪", supported: true },
  { code: "GR", name: "Greece", flag: "🇬🇷", supported: true },
  { code: "HU", name: "Hungary", flag: "🇭🇺", supported: true },
  { code: "IE", name: "Ireland", flag: "🇮🇪", supported: true },
  { code: "IT", name: "Italy", flag: "🇮🇹", supported: true },
  { code: "LV", name: "Latvia", flag: "🇱🇻", supported: true },
  { code: "LT", name: "Lithuania", flag: "🇱🇹", supported: true },
  { code: "LU", name: "Luxembourg", flag: "🇱🇺", supported: true },
  { code: "MT", name: "Malta", flag: "🇲🇹", supported: false },
  { code: "NL", name: "Netherlands", flag: "🇳🇱", supported: true },
  { code: "PL", name: "Poland", flag: "🇵🇱", supported: true },
  { code: "PT", name: "Portugal", flag: "🇵🇹", supported: true },
  { code: "RO", name: "Romania", flag: "🇷🇴", supported: true },
  { code: "SK", name: "Slovakia", flag: "🇸🇰", supported: false },
  { code: "SI", name: "Slovenia", flag: "🇸🇮", supported: false },
  { code: "ES", name: "Spain", flag: "🇪🇸", supported: true },
  { code: "SE", name: "Sweden", flag: "🇸🇪", supported: true },
  { code: "TR", name: "Türkiye", flag: "🇹🇷", supported: false },
];

export const continents = [
  {
    name: "Europe",
    countries: euCountries
  },
  {
    name: "North America", 
    countries: [
      { code: "US", name: "United States", flag: "🇺🇸", supported: true },
      { code: "CA", name: "Canada", flag: "🇨🇦", supported: true },
      { code: "MX", name: "Mexico", flag: "🇲🇽", supported: false },
    ]
  },
  {
    name: "South America",
    countries: [
      { code: "BR", name: "Brazil", flag: "🇧🇷", supported: false },
      { code: "AR", name: "Argentina", flag: "🇦🇷", supported: false },
      { code: "CL", name: "Chile", flag: "🇨🇱", supported: false },
      { code: "CO", name: "Colombia", flag: "🇨🇴", supported: false },
    ]
  },
  {
    name: "Asia",
    countries: [
      { code: "CN", name: "China", flag: "🇨🇳", supported: false },
      { code: "JP", name: "Japan", flag: "🇯🇵", supported: false },
      { code: "IN", name: "India", flag: "🇮🇳", supported: false },
      { code: "KR", name: "South Korea", flag: "🇰🇷", supported: false },
    ]
  },
  {
    name: "Africa",
    countries: [
      { code: "ZA", name: "South Africa", flag: "🇿🇦", supported: false },
      { code: "NG", name: "Nigeria", flag: "🇳🇬", supported: false },
      { code: "EG", name: "Egypt", flag: "🇪🇬", supported: false },
      { code: "KE", name: "Kenya", flag: "🇰🇪", supported: false },
    ]
  },
  {
    name: "Oceania",
    countries: [
      { code: "AU", name: "Australia", flag: "🇦🇺", supported: false },
      { code: "NZ", name: "New Zealand", flag: "🇳🇿", supported: false },
      { code: "FJ", name: "Fiji", flag: "🇫🇯", supported: false },
    ]
  },
  {
    name: "Antarctica",
    countries: [
      { code: "AQ", name: "Antarctica", flag: "🇦🇶", supported: false },
    ]
  }
];
